import Select from 'react-select'
import {useTranslation} from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import FormGateway from '../../../gateway/Form/FormGateway';

export interface ISelectFormProps {
  onSelectChange: (formId: string|null) => void;
  folderState?: string|undefined
}

const SelectForm: FC<ISelectFormProps> = ({onSelectChange, folderState}) => {
  const {t} = useTranslation()
  const [formOptions, setFormOptions] = useState<{ value: string; label: string; }[]>([{ 
    value: 'all', label: 'Toutes les souscriptions',
  }])

  useEffect(() => {
    new FormGateway().getForms().then(forms => {
      if (null !== forms) {
        const initialList = formOptions
        const transformedArray = forms.map(item => ({
          value: item.id,
          label: item.label,
        }));
        initialList.push(...transformedArray)
        if ('ongoing' === folderState) {
          initialList.push(...[{value: 'warning', label: 'Souscriptions à vérifier'}])
        }
        setFormOptions(initialList)
      }
    })
  }, [setFormOptions])

  return (
    <>
      {formOptions.length > 0 && (
        <Select
          menuPosition="absolute"
          menuPortalTarget={document.body}
          placeholder={t('common.select-placeholder')}
          options={formOptions}
          defaultValue={formOptions[0]}
          isMulti={false}
          isClearable={false}
          onChange={val => {
            onSelectChange(val.value !== 'all' ? val.value : null)
          }}
        />
      )}
    </>
  )
};

export default SelectForm;
